/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useSelectLang } from "@hooks/useLang";
import { copyallCommissionCalculation, getCommissionCalculation } from "@api/cms";
import { IMAGE_DOMAIN } from "@constants/api";
import CommissionCalculationModal from "@components/commissioncalculation/CommissionCalculationModal";
import QuicklyCopySettings from "@components/shared/QuicklyCopySettings";
import { Card, Button, Icon } from "@mui/material";

export default function CommissionCalculationPage() {
  const { lang } = useSelectLang();
  const [commissionCalculation, setCommissionCalculation] = useState(null);

  const [selectedCalculation, setSelectedCalculation] = useState(null);

  const getData = async () => {
    const res = await getCommissionCalculation(lang);
    setCommissionCalculation(
      res
        ? res.map((r) => {
          return { ...r, imgUrl: `${IMAGE_DOMAIN}/${r.imagePath}` };
        })
        : []
    );

  };

  useEffect(() => {
    getData();
  }, [lang]);

  const addCommissionCalculation = () => {
    setSelectedCalculation({
      isAddNew: true,
      id: -1,
      title: "",
      image: null,
      imgUrl: "",
      language: lang,
      sort: 1,
    });
  };

  const handleCloseModal = async (reGetData) => {
    if (reGetData) await getData();
    setSelectedCalculation(null);
  };

  const handleQuicklyCopySubmit = async (toLanguage) => {
    if (!lang || !toLanguage) {
      toast.error("請重新整理網頁後再嘗試");
    } else {
      const res = await copyallCommissionCalculation({ fromLanguage: lang, toLanguage });
      if (res && typeof res === "object" && commissionCalculation)
        if (res?.length === commissionCalculation?.length)
          toast.success(`複製到 ${toLanguage} 成功`);
    }
  };

  return (
    <Card
      elevation={3}
      className="w-full overflow-auto"
      style={{ padding: "24px" }}
    >
      <CommissionCalculationPageWrap>
        <QuicklyCopySettings onSubmit={handleQuicklyCopySubmit} />
        佣金試算說明 - 250 x 250（長x寬）。<strong>圖片檔名不可重複</strong>
        <br />
        {`教學：點擊"新增佣金試算"按鈕，或者圖片來打開新增/修改視窗。-> 右上角"X"按鈕用於關閉。視窗內最下方的儲存/刪除按鈕提供該名稱所對應的功能。`}

        <Button
          variant="contained"
          color="secondary"
          onClick={addCommissionCalculation}
          mt={10}
        >
          <Icon>add</Icon>&nbsp;
          新增佣金試算
        </Button>

        <div className="calculation-wrap">
          {commissionCalculation &&
            commissionCalculation.map((c) => (
              <div key={c.id} onClick={() => setSelectedCalculation(c)}>
                <img src={c.imgUrl} alt={`${c.title}-${c.id}`} />
                <p className="calculation-title">{c.title}</p>
              </div>
            ))}
        </div>
        <CommissionCalculationModal
          show={selectedCalculation !== null}
          item={selectedCalculation}
          onClose={handleCloseModal}
        />
      </CommissionCalculationPageWrap>
    </Card>
  );
}

const CommissionCalculationPageWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .calculation-wrap {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    box-sizing: border-box;

    > div {
      margin: auto 0px;
      width: 200px;
      cursor: pointer;
      > img {
        width: 100%;
        height: auto;
      }
      .calculation-title {
        text-align: center;
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }

  > button {
    margin: 10px 0px;
    width: 200px;
  }
`;